module.exports = __webpack_public_path__ + "img/client.38b54101.png";